import type { LoginRequestDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

export function useLogin() {
	return useApiMutation(
		"post",
		"/auth/login",
		{
			notify: false,
			mapVariables: (data: LoginRequestDto) => ({
				body: data,
				headers: {
					"x-auth-request": "true",
				},
				credentials: "include",
			}),
		},
	);
}
